import { DEFAULTS_ALIGN } from '../../slatePlugins/elements/align/defaults';
import { DEFAULTS_HEADING } from '../../slatePlugins/elements/heading/defaults';
import { DEFAULTS_LIST } from '../../slatePlugins/elements/list/defaults';
import { DEFAULTS_PARAGRAPH } from '../../slatePlugins/elements/paragraph/defaults';
import { DEFAULTS_BOLD } from '../../slatePlugins/marks/bold/defaults';
import { DEFAULTS_ITALIC } from '../../slatePlugins/marks/italic/defaults';
import { DEFAULTS_STRIKETHROUGH } from '../../slatePlugins/marks/strikethrough/defaults';
import { DEFAULTS_UNDERLINE } from '../../slatePlugins/marks/underline/defaults';

export const DEFAULTS_OPTIONS = {
  // elements
  ...DEFAULTS_HEADING,
  ...DEFAULTS_LIST,
  ...DEFAULTS_PARAGRAPH,

  // text format
  ...DEFAULTS_BOLD,
  ...DEFAULTS_ITALIC,
  ...DEFAULTS_UNDERLINE,
  ...DEFAULTS_STRIKETHROUGH,
  ...DEFAULTS_ALIGN,
};
